import Cookies from 'js-cookie'
const getToken = () => {
  if (typeof window !== "undefined") {
    return Cookies.get('token') || null;
  } else {
    return false
  }
};
const Api = async (url, method, data = {}, isFormData = false) => {

  const token = getToken();
  const headers = new Headers({
    Authorization: token,
    "Content-Type": "application/json",
  });
  const config = {
    method: method,
    headers: headers,
  };
  if (method !== "GET" && method !== "HEAD" && method !== "DELETE") {
    config.body = isFormData ? data : JSON.stringify(data);
  }
  try {
    const response = await fetch(url, config);
    const jsonData = await response.json();
    if (!response.ok) {
      throw new Error(jsonData.message || "API call failed");
    }
    return jsonData;
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
};

export default Api;


